import styled, { css } from 'styled-components';
import Select from 'products/nomad_insurance/components/Select';
import { th, variants } from 'style/theme';
import { sizes } from 'style';

export const Container = styled.div`
  position: relative;
  margin-bottom: 22px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SelectContainer = styled.div`
  display: flex;
  gap: 8px;
  @media ${sizes.desktop} {
    gap: 12px;
  }
`;

export const DefaultSelectWrapper = styled.div`
  position: relative;
  :nth-child(1) {
    width: 42%;
  }
  :nth-child(2) {
    width: 27%;
  }
  :nth-child(3) {
    width: 31%;
  }
  > svg {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    @media ${sizes.desktop} {
      right: 16px;
    }
  }
  > select {
    border-radius: 16px;
    padding: 8px 12px;
    padding-top: 22px;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    font-family: Inter;
    height: 56px;
    color: ${th('colors.pickledBluewood')};
    ${variants('variant', {
      white: css`
        background-color: ${th('colors.white')};
        border-bottom: 1px solid ${th('colors.white')};
      `
    })}
    > option[disabled] {
      display: none;
    }
    width: 100%;
    -moz-appearance: none;
    -webkit-appearance: none;
    ::-ms-expand {
      display: none;
    }
  }
`;

export const Label = styled.div`
  position: absolute;
  left: 12px;
  top: 8px;
  font-size: 12px;
  color: ${th('colors.osloGray')};
  margin: 0;
  pointer-events: none;
`;

export const StyledSelect = styled(Select)`
  margin-bottom: 0;
  :nth-child(1) {
    width: 42%;
  }
  :nth-child(2) {
    width: 27%;
  }
  :nth-child(3) {
    width: 31%;
  }
`;

export const DisabledDate = styled.div`
  opacity: 0.7;
`;
